import { render, staticRenderFns } from "./IncomeTax.vue?vue&type=template&id=2d47e0d0&scoped=true"
import script from "./IncomeTax.vue?vue&type=script&lang=js"
export * from "./IncomeTax.vue?vue&type=script&lang=js"
import style0 from "./IncomeTax.vue?vue&type=style&index=0&id=2d47e0d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47e0d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d47e0d0')) {
      api.createRecord('2d47e0d0', component.options)
    } else {
      api.reload('2d47e0d0', component.options)
    }
    module.hot.accept("./IncomeTax.vue?vue&type=template&id=2d47e0d0&scoped=true", function () {
      api.rerender('2d47e0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/CandidateData/PersonalDocument/IncomeTax.vue"
export default component.exports